<template>
  <div class="step-menu">
    <div
      v-for="(item, index) in standaloneStepMenuList"
      class="step-menu-item"
      :key="item.stepType"
      :class="index === activeIndex && 'is-active'"
      @click="handleStepChange(item, index)"
    >
      <div class="step-node" :class="getNodeType(item, index)">
        <i class="node-icon" :class="getNodeIconClass(item, index)"></i>
      </div>
      <div class="step-icon">
        <i :class="item.iconClass"></i>
      </div>
      <div class="step-name">{{ getMenuItemLabel(item, index) }}</div>
    </div>
  </div>
</template>

<script>
import { NODE_TYPE } from '@/constant/stepMenu'

export default {
  components: {
  },
  model: {
    prop: 'activeIndex',
    event: 'change'
  },
  props: {
    activeIndex: {
      type: Number,
      required: true
    },
    standaloneStepMenuList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    getNodeType (menuItem, index) {
      return this.activeIndex === index ? NODE_TYPE.PROCESSING : NODE_TYPE.PENDING
    },
    getMenuItemLabel (menuItem) {
      if (menuItem.hasOwnProperty('label')) {
        return menuItem.label
      } else if (menuItem.hasOwnProperty('labelI18nKey')) {
        return this.$t(menuItem.labelI18nKey)
      } else {
        return ''
      }
    },
    getNodeIconClass (menuItem, index) {
      return this.activeIndex === index ? 'el-icon-more' : ''
    },
    handleStepChange (stepItem, index) {
      this.$emit('change', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.step-menu {
  .step-menu-item {
    display: flex;
    height: 50px;
    margin-bottom: 15px;
    padding: 15px 25px;
    border-radius: 5px;
    align-items: center;
    cursor: pointer;
    position: relative;

    .step-icon {
      width: 22px;
      color: #ffffff;

      i {
        font-size: 22px;
      }
    }

    .step-name {
      margin-left: 40px;
      vertical-align: middle;
      color: #ffffff;
    }

    .step-node {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      line-height: 1;
      color: #ffffff;
      background-color: #9c9c9c;
      transform: translate(-50%, -50%);
      position: absolute;
      top: 50%;
      left: 65px;

      &.available {
        background-color: #ffffff;
        color: #14a965;

        .node-icon {
          font-size: 24px;

          &::before {
            display: block;
            margin-top: -2px;
            margin-left: -2px;
          }
        }
      }

      &.processing {
        .node-icon {
          color: #ffffff;
          font-size: 16px;

          &::before {
            display: block;
            margin-top: 2px;
            margin-left: 2px;
          }
        }
      }

      &.pending {
        padding: 4px;

        .node-icon {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background-color: #ffffff;
        }
      }
    }
  }
}
</style>
